<template>
  <DefaultPage id="leadership">
    <div class="leadership">
      <div class="hero">
        <HeroTexture class="hero-texture" />
        <HeroTextureTwo class="hero-texture-two" />
        <div class="hero-flex-wrap">
          <div class="hero__call">
            <h1
              class="hero__headline"
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              Leadership
            </h1>
            <div
              class="hero__call__content"
              data-aos="fade-left"
              data-aos-duration="1000"
            >
              <p>A team dedicated to our mission and our members.</p>
            </div>
          </div>
        </div>
      </div>
      <VisualDataSection
        id="board-of-directors"
        title="Our Board of Directors"
      >
        <div class="grid-x grid-margin-x medium-up-2 large-up-3 xlarge-up-4 leadership-grid">
          <div class="cell leadership-grid__block">
            <h4>Matthew L. Perkins, MD</h4>
            <h6>Chair of the Board</h6>
            <p>Internal Medicine and Pediatrics</p>
            <p>Tennessee Medicine and Pediatrics PC</p>
            <p>Smyrna, Tennessee</p>
            <p>Director Since 2008</p>
            <p>Chair Since 2024</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Katrina M. Hood, MD</h4>
            <h6>Vice Chair of the Board</h6>
            <p>Pediatrics</p>
            <p>Pediatric and Adolescent Associates PSC</p>
            <p>Lexington, Kentucky</p>
            <p>Director Since 2009</p>
            <p>Vice Chair Since 2024</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Craig A. Myers, MD</h4>
            <h6>Secretary of the Board</h6>
            <p>Obstetrics/Gynecology</p>
            <p>Generations OB/GYN</p>
            <p>Knoxville, Tennessee</p>
            <p>Director Since 2021</p>
            <p>Secretary Since 2024</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Chad T. Couch, MD, MBA</h4>
            <h6>Treasurer of the Board</h6>
            <p>Urology</p>
            <p>President, Northeast Market</p>
            <p>CEO, Bristol Regional Medical Center</p>
            <p>Bristol, Tennessee</p>
            <p>Director Since 2008</p>
            <p>Treasurer Since 2022</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Hugh Francis, III, MD</h4>
            <h6>Chair Emeritus</h6>
            <p>General and Vascular Surgery</p>
            <p>Memphis Surgery Associates</p>
            <p>Memphis, Tennessee</p>
            <p>Director Since 1997</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Brady W. Allen, MD</h4>
            <p>Emergency Medicine</p>
            <p>Ascension Saint Thomas</p>
            <p>Nashville, Tennessee</p>
            <p>Director Since 2020</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Melanie B. Blake, MD, MBA</h4>
            <p>Internal Medicine</p>
            <p>Medical Consultant, Unum</p>
            <p>Hospitalist, Rhea Medical Center</p>
            <p>Chattanooga, Tennessee</p>
            <p>Director Since 2018</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Ravi D. Chauhan, MD</h4>
            <p>Urology</p>
            <p>The Conrad Pearson Clinic</p>
            <p>Memphis, Tennessee</p>
            <p>Director Since 2023</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>JimBob Faulk, MD</h4>
            <p>Vascular and Endovascular Surgery</p>
            <p>The Surgical Clinic, PLLC</p>
            <p>Nashville, Tennessee</p>
            <p>Director Since 2024</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>John O. Lytle, MD</h4>
            <p>Orthopedic Surgery</p>
            <p>South Arkansas Orthopaedic Center</p>
            <p>Pine Bluff, Arkansas</p>
            <p>Director Since 2006</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Russell E. Miller, CAE</h4>
            <p>Chief Executive Officer</p>
            <p>Tennessee Medical Association</p>
            <p>Nashville, Tennessee</p>
            <p>Director Since 2013</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Ryan D. Mire, MD</h4>
            <p>Internal Medicine</p>
            <p>Heritage Medical Associates</p>
            <p>Nashville, Tennessee</p>
            <p>Director Since 2023</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>John H. Mize, FCAS, MAAA</h4>
            <p>President and Chief Executive Officer</p>
            <p>SVMIC</p>
            <p>Brentwood, Tennessee</p>
            <p>Director Since 2013</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Antwan D. Robinson, MD</h4>
            <p>Cardiology</p>
            <p>Jackson Clinic, PA</p>
            <p>Jackson, Tennessee</p>
            <p>Director Since 2021</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Elise E. Schriver, MD</h4>
            <p>Pulmonary and Critical Care Medicine</p>
            <p>University Pulmonary & Critical Care</p>
            <p>Knoxville, Tennessee</p>
            <p>Director Since 2002</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Jane M. Sneed, MD</h4>
            <p>Pediatrics</p>
            <p>The Children’s Clinic</p>
            <p>Jonesboro, Arkansas</p>
            <p>Director Since 2013</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Lisa J. Young, MD</h4>
            <p>Cardiology</p>
            <p>Sutherland Cardiology Clinic, Inc.</p>
            <p>Germantown, Tennessee</p>
            <p>Director Since 2013</p>
          </div>
        </div>
      </VisualDataSection>
      <VisualDataSection
        id="committees"
        useTextureBackground
      >
        <template v-slot:header>
          <h3>Committees of the Board</h3>
          <span class="footnote">*Non-Member Consultant</span>
        </template>
        <div class="grid-x grid-margin-x medium-up-2 large-up-3 xlarge-up-4 committee-grid">
          <div class="cell committee-grid__block">
            <h3>Arkansas Advisory Committee</h3>
            <p>Jane M. Sneed, MD, Chair</p>
            <p>J. Greg Elders, MD</p>
            <p>Patrick J. Flaherty, DO</p>
            <p>Keitha DeWitt Holland, MD</p>
            <p>John O. Lytle, MD</p>
            <p>Juan C. Roman, MD</p>
          </div>
          <div class="cell committee-grid__block">
            <h3>Audit Committee</h3>
            <p>Lisa J. Young, MD, Chair</p>
            <p>Melanie B. Blake, MD</p>
            <p>John O. Lytle, MD</p>
            <p>David A. Curbo, CPA Inactive*</p>
          </div>
          <div class="cell committee-grid__block">
            <h3>Budget Committee</h3>
            <p>Elise E. Schriver, MD, Chair</p>
            <p>Brady W. Allen, MD</p>
            <p>Chad T. Couch, MD</p>
            <p>Hugh Francis, III, MD</p>
            <p>Katrina M. Hood, MD</p>
            <p>John O. Lytle, MD</p>
            <p>Matthew L. Perkins, MD </p>
            <p>Lisa J. Young, MD</p>
          </div>
          <div class="cell committee-grid__block">
            <h3>Claims Management Core Committee</h3>
            <p>Elise E. Schriver, MD, Chair</p>
            <p>Chad T. Couch, MD</p>
            <p>Hugh Francis, III, MD</p>
            <p>Katrina M. Hood, MD</p>
            <p>John O. Lytle, MD</p>
            <p>Matthew L. Perkins, MD </p>
          </div>
          <div class="cell committee-grid__block">
            <h3>Claims Management Committee Consultants</h3>
            <p>Issam M. Almashharawi, MD</p>
            <p>Robert G. "Greg" Chandler, MD</p>
            <p>Jon S. Cohen, MD</p>
            <p>Daniel S. Ely, MD</p>
            <p>Keith L. Goldberg, MD</p>
            <p>William J. Harb, MD</p>
            <p>Jennifer L. Jacks, MD</p>
            <p>Brian M. Jerkins, MD</p>
            <p>Rafal Kedzierski, MD, PhD</p>
            <p>Robert H. Miller, III, MD</p>
            <p>Jennifer L. Mosley, MD</p>
            <p>J. Philip Moyers, MD</p>
            <p>Michael K. Muhlert, MD</p>
            <p>Alan P. Mullins, MD</p>
            <p>Frank J. Murabito, MD</p>
            <p>E. Lee Murray, II, MD</p>
            <p>Joseph P. Parker, MD</p>
            <p>Amit S. Patel, MD</p>
            <p>David C. Portnoy, MD</p>
            <p>Chris E. Rickman, MD</p>
            <p>Adam L. Summerlin, MD</p>
          </div>
          <div class="cell committee-grid__block">
            <h3>Compensation Committee</h3>
            <p>Elise E. Schriver, MD, Chair</p>
            <p>Brady W. Allen, MD</p>
            <p>Chad T. Couch, MD</p>
            <p>Hugh Francis, III, MD</p>
            <p>Katrina M. Hood, MD</p>
            <p>John O. Lytle, MD</p>
            <p>Matthew L. Perkins, MD</p>
            <p>Lisa J. Young, MD</p>
            <p>Matt Leach*</p>
          </div>
          <div class="cell committee-grid__block">
            <h3>Executive Committee</h3>
            <p>Katrina M. Hood, MD, Chair</p>
            <p>Chad T. Couch, MD</p>
            <p>Hugh Francis, III, MD</p>
            <p>John H. Mize, FCAS, MAAA</p>
            <p>Craig A. Myers, MD</p>
            <p>Matthew L. Perkins, MD</p>
            <p>Elise E. Schriver, MD</p>
            <p>Lisa J. Young, MD</p>
          </div>
          <div class="cell committee-grid__block">
            <h3>Innovation Task Force</h3>
            <p>Brady W. Allen, MD, Lead Physician</p>
            <p>Ravi D. Chauhan, MD</p>
            <p>Hugh Francis, III, MD</p>
            <p>Katrina M. Hood, MD</p>
            <p>John O. Lytle, MD</p>
            <p>Craig A. Myers, MD</p>
            <p>Matthew L. Perkins, MD</p>
            <p>Antwan D. Robinson, MD</p>
            <p>Elise E. Schriver, MD</p>
            <p>Jane M. Sneed, MD</p>
          </div>
          <div class="cell committee-grid__block">
            <h3>Investment Committee</h3>
            <p>Chad T. Couch, MD, Chair</p>
            <p>Brady W. Allen, MD</p>
            <p>Hugh Francis, III, MD</p>
            <p>Katrina M. Hood, MD</p>
            <p>John O. Lytle, MD</p>
            <p>Matthew L. Perkins, MD</p>
            <p>Elise E. Schriver, MD</p>
            <p>Lisa J. Young, MD</p>
          </div>
          <div class="cell committee-grid__block">
            <h3>Risk Management Committee</h3>
            <p>Elise E. Schriver, MD, Chair</p>
            <p>J. Michelle Allmon, MD </p>
            <p>Michael S. Dolan, MD</p>
            <p>Daniel S. Ely, MD</p>
            <p>JimBob Faulk, MD</p>
            <p>Scott R. Fowler, MD</p>
            <p>Hugh Francis, III, MD </p>
            <p>Katrina M. Hood, MD </p>
            <p>Charles S. Joels, MD </p>
            <p>John O. Lytle, MD</p>
            <p>Matthew L. Perkins, MD</p>
            <p>Antwan D. Robinson, MD</p>
            <p>Matthew P. Willis, MD</p>
          </div>
          <div class="cell committee-grid__block">
            <h3>Succession Planning Committee</h3>
            <p>Matthew L. Perkins, MD, Chair</p>
            <p>Hugh Francis, III, MD</p>
            <p>Katrina M. Hood, MD </p>
            <p>John O. Lytle, MD</p>
            <p>John H. Mize, FCAS, MAAA</p>
            <p>Michael A. Ricciardelli, CPA</p>
            <p>Elise E. Schriver, MD</p>
            <p>Matt Leach*</p>
          </div>
          <div class="cell committee-grid__block">
            <h3>Underwriting Committee</h3>
            <p>Lisa J. Young, MD, Chair</p>
            <p>Brady W. Allen, MD</p>
            <p>Mark E. Bigler, MD</p>
            <p>Ravi D. Chauhan, MD</p>
            <p>Chad T. Couch, MD</p>
            <p>Anthony T. Everhart, MD</p>
            <p>Hugh Francis, III, MD</p>
            <p>Katrina M. Hood, MD </p>
            <p>Benjamin L. Huff, MD</p>
            <p>John O. Lytle, MD</p>
            <p>Clinton A. Marlar, MD</p>
            <p>Ryan D. Mire, MD</p>
            <p>Craig A. Myers, MD</p>
            <p>Matthew L. Perkins, MD</p>
            <p>Jason A. Weaver, MD</p>
          </div>
        </div>
      </VisualDataSection>
      <VisualDataSection
        id="officers"
        title="Our Officers"
      >
        <div class="grid-x grid-margin-x medium-up-2 large-up-3 xlarge-up-4 leadership-grid">
          <div class="cell leadership-grid__block">
            <h4>Matthew L. Perkins, MD</h4>
            <p>Chair of the Board</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Katrina M. Hood, MD</h4>
            <p>Vice Chair of the Board</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Craig A. Myers, MD</h4>
            <p>Secretary of the Board</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Chad T. Couch, MD, MBA</h4>
            <p>Treasurer of the Board</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Hugh Francis, III, MD</h4>
            <p>Chair Emeritus</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>John H. Mize, FCAS, MAAA</h4>
            <p>President and Chief Executive Officer</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Michael A. Ricciardelli, CPA</h4>
            <p>Chief Financial Officer</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Stephen A. Dickens, JD, FACMPE</h4>
            <p>Vice President,<br/>Medical Practice Services</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Joseph J. Lebryk</h4>
            <p>Vice President,<br/>Business Development</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Andy J. Meyers</h4>
            <p>Vice President,<br/>Information Systems</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Kenneth W. Rucker, JD</h4>
            <p>Vice President,<br/>Claims</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Charmy M. Shrode</h4>
            <p>Vice President,<br/>Underwriting</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Shelly E. Weatherly, JD</h4>
            <p>Vice President,<br/>Risk Education and Evaluation Services</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Tom C. Werner, FCAS, MAAA</h4>
            <p>Vice President,<br/>Actuarial and Business Analytics</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Jackie P. Boswell, MBA, FACMPE</h4>
            <p>Assistant Vice President,<br/>Medical Practice Services</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Robin Buter, BSN, RN, LNCC</h4>
            <p>Assistant Vice President,<br/>Risk Evaluation Services</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Dan Himmelberg, JD</h4>
            <p>Assistant Vice President,<br/>Claims</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Julie Loomis, RN, JD</h4>
            <p>Assistant Vice President,<br/>Risk Education</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Judy Musgrove, ACC</h4>
            <p>Assistant Vice President,<br/>Marketing and Communications</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Savannah Pyles</h4>
            <p>Assistant Vice President,<br/>Underwriting</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Deborah D. Rose, RN, LNC</h4>
            <p>Assistant Vice President,<br/>Medical Information Services</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Alisa S. Wamble, JD</h4>
            <p>Assistant Vice President,<br/>Claims</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Jessica E. Elston</h4>
            <p>Controller</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Renee A. Lewis</h4>
            <p>Director,<br/>Claims Operations and Assistant Corporate Secretary</p>
          </div>
          <div class="cell leadership-grid__block">
            <h4>Patrick T. McBride, CPA</h4>
            <p>Director,<br/>Financial Reporting and Assistant Corporate Secretary</p>
          </div>
        </div>
      </VisualDataSection>
      <TheSubFooter next-route="/about" />
    </div>
  </DefaultPage>
</template>

<script>
import DefaultPage from '@/layouts/DefaultPage';
import TheSubFooter from '@/components/footer/TheSubFooter';
import VisualDataSection from '@/components/section/VisualDataSection';
import HeroTexture from '@/assets/texture-leadership-hero.svg';
import HeroTextureTwo from '@/assets/texture-leadership-hero-2.svg';

export default {
  name: 'Leadership',
  components: {
    VisualDataSection,
    DefaultPage,
    TheSubFooter,
    HeroTexture,
    HeroTextureTwo,
  }
};
</script>
